import { BaseResponseSchema, ChangeProviderUserRoleRequestSchema, ChangeProviderUserStatusRequestSchema, CreateProviderUserRequestSchema, CreateProviderUserResponseSchema, GetProviderUsersRequestSchema, ProviderUserResponseSchema, ProviderUsersListResponseSchema, ResendProviderUserInvitationResponseSchema, UpdateProviderUserRequestSchema, UserIdParamSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/provider-users.routes.ts`. */
export const providerUsersContract = {
    list: {
        method: 'GET',
        path: '/provider/users',
        query: GetProviderUsersRequestSchema,
        response: ProviderUsersListResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'users',
        queryLimitMax: 100,
        errorMessage: 'Failed to list provider users',
    },
    getById: {
        method: 'GET',
        path: '/provider/users/:userId',
        pathParams: UserIdParamSchema,
        response: ProviderUserResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'user',
        errorMessage: 'Failed to get provider user',
    },
    create: {
        method: 'POST',
        path: '/provider/users',
        body: CreateProviderUserRequestSchema,
        response: CreateProviderUserResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 30000,
        errorMessage: 'Failed to create provider user',
    },
    update: {
        method: 'PUT',
        path: '/provider/users/:userId',
        pathParams: UserIdParamSchema,
        body: UpdateProviderUserRequestSchema,
        response: ProviderUserResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'user',
        errorMessage: 'Failed to update provider user',
    },
    changeStatus: {
        method: 'PATCH',
        path: '/provider/users/:userId/status',
        pathParams: UserIdParamSchema,
        body: ChangeProviderUserStatusRequestSchema,
        response: ProviderUserResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'user',
        errorMessage: 'Failed to change provider user status',
    },
    changeRole: {
        method: 'PATCH',
        path: '/provider/users/:userId/role',
        pathParams: UserIdParamSchema,
        body: ChangeProviderUserRoleRequestSchema,
        response: ProviderUserResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'user',
        errorMessage: 'Failed to change provider user role',
    },
    delete: {
        method: 'DELETE',
        path: '/provider/users/:userId',
        pathParams: UserIdParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete provider user',
    },
    resendInvitation: {
        method: 'POST',
        path: '/provider/users/:userId/resend-invitation',
        pathParams: UserIdParamSchema,
        response: ResendProviderUserInvitationResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 30000,
        errorMessage: 'Failed to resend provider user invitation',
    },
};
//# sourceMappingURL=provider-users.contract.js.map